import { createSelector } from 'reselect';
import { userInitSelector } from './features/userInit/selectors';
import { IUserInitEnums } from './features/userInit/types';

export const initSurveySelector = createSelector(
  userInitSelector,
  (init: IUserInitEnums) =>
    init?.survey_type?.map((item) => ({
      id: item.key,
      name: item.name,
    })),
);

export const initQuestionSelector = createSelector(
  userInitSelector,
  (init: IUserInitEnums) =>
    init?.question_type?.map((item) => ({
      id: item.key,
      name: item.name,
    })),
);
